module.exports = __webpack_public_path__ + "AvenirLTStd-Heavy.a7edaaca7240679d0cda.otf";


//////////////////
// WEBPACK FOOTER
// /Users/mohammed/Desktop/OldLaptop/www-data/www-data/htdocs/remoteApi-front/ng-app/src/assets/fonts/AvenirLTStd-Heavy.otf
// module id = ../../../../../src/assets/fonts/AvenirLTStd-Heavy.otf
// module chunks = styles